import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateMemberIdTimeoff", function updateMemberIdTimeoff(memberId: string) {
    if (shiftEditorViewState().timeoff) {
        shiftEditorViewState().timeoff.memberId = memberId;
    }
});